import 'flatpickr/dist/themes/airbnb.css'
import {Field} from 'formik'
import {useIntl} from 'react-intl'
import InputMask from 'react-input-mask'
import {useGetContactTitleList} from 'src/feature/store/context/useQuery'
import {useStore} from 'src/feature/store/hook'
import Select from 'react-select'

export default function FormStarted({
  token,
  errors,
  touched,
  setTouched,
  values,
  setFieldValue,
  isLoading,
  setIsLoading,
  handleSubmit,
}: {
  token: {
    userID: string
    token: string
  }
  errors: any
  touched: any
  values: any
  setFieldValue: any
  list?: {countries: any[]; cities: any[]; regions: any[]}
  changeCountry?: (countryId: string) => void
  changeCity?: (cityId: string) => void
  isLoading?: boolean
  setIsLoading?: (value: boolean) => void
  setTouched?: any
  handleSubmit?: any
}) {
  const {isLoading: isLoadingTitle} = useGetContactTitleList(token)
  const {storeContactTitleList} = useStore()

  const intl = useIntl()

  const selects = storeContactTitleList?.map((item) => {
    return {
      value: item.id,
      label: item.name,
    }
  })

  return (
    <div className='w-100 p-5'>
      <div className='d-flex flex-column flex-lg-row w-100 gap-5'>
        <div className='w-100'>
          <div className='card card-bordered'>
            <div className='card-header'>
              <div className='card-title d-flex flex-column pt-5'>
                <h3 className='text-primary '>
                  {/* Merchant Information */}
                  {intl.formatMessage({id: 'MERCHANT_INFORMATION'})}
                </h3>
                <p className=''>
                  {/* Please get in touch with your ISO to update the following details. */}
                  {intl.formatMessage({id: 'PLEASE_GET_IN_TOUCH'})}
                </p>
              </div>
            </div>
            <div className='card-body d-flex flex-column gap-5 card-disabled'>
              <div className='d-flex gap-5'>
                <div className='w-50'>
                  <div className='form-group'>
                    <label className='form-label'>
                      {/* ISO ID */}
                      {intl.formatMessage({id: 'ISO_ID'})}
                    </label>
                    <Field type='text' name='isoid' className='form-control' disabled />
                  </div>
                </div>
                <div className='w-100'>
                  <div className='form-group'>
                    <label className='form-label'>
                      {/* ISO Name */}
                      {intl.formatMessage({id: 'ISO_NAME'})}
                    </label>
                    <Field type='text' name='isoName' className='form-control' disabled />
                  </div>
                </div>
              </div>
              <div className='d-flex gap-5'>
                <div className='w-50'>
                  <label className='form-label'>
                    {/* Merchant ID */}
                    {intl.formatMessage({id: 'MERCHANT_ID'})}
                  </label>
                  <Field type='text' name='merchantID' className='form-control' disabled />
                </div>
                <div className='w-100'>
                  <div className='form-group'>
                    <label className='form-label'>
                      {/* Merchant Name */}
                      {intl.formatMessage({id: 'MERCHANT_NAME'})}
                    </label>
                    <Field type='text' name='merchantName' className='form-control' disabled />
                  </div>
                </div>
              </div>
              <div className='w-50'>
                <div className='form-group'>
                  <label className='form-label'>
                    {/* Email */}
                    {intl.formatMessage({id: 'EMAIL'})}
                  </label>
                  <Field type='text' name='merchantEmail' className='form-control' disabled />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='w-100'>
          <div className='card card-bordered'>
            <div className='card-header'>
              <div className='card-title d-flex flex-column pt-5'>
                <h3 className='text-primary '>
                  {/* Contact Information */}
                  {intl.formatMessage({id: 'CONTACT_INFORMATION'})}
                </h3>
                <p className=''>
                  {/* Feel free to edit the following fields. */}
                  {intl.formatMessage({id: 'FEEL_FREE_TO_EDIT'})}
                </p>
              </div>
            </div>
            <div className='card-body d-flex flex-column gap-5'>
              <div className='d-flex gap-5'>
                <div className='w-100'>
                  <div className='form-group'>
                    <label className='form-label'>
                      {/* Name */}
                      {intl.formatMessage({id: 'NAME'})}

                      <span className='text-danger'> *</span>
                    </label>
                    <Field
                      type='text'
                      name='name'
                      className='form-control'
                      placeholder={intl.formatMessage({id: 'NAME'})}
                      maxLength={51}
                    />
                    {errors.name && touched.name && (
                      <div className='text-danger'>{errors.name}</div>
                    )}
                  </div>
                </div>
                <div className='w-100'>
                  <div className='form-group'>
                    <label className='form-label'>
                      {/* Last Name */}
                      {intl.formatMessage({id: 'LAST_NAME'})}

                      <span className='text-danger'> *</span>
                    </label>
                    <Field
                      type='text'
                      name='surname'
                      className='form-control'
                      // placeholder='Surname'
                      placeholder={intl.formatMessage({id: 'LAST_NAME'})}
                      maxLength={51}
                    />
                    {errors.surname && touched.surname && (
                      <div className='text-danger'>{errors.surname}</div>
                    )}
                  </div>
                </div>
              </div>

              <div className='d-flex gap-5'>
                <div className='w-100'>
                  <div className='form-group'>
                    <label className='form-label'>
                      {/* Email */}
                      {intl.formatMessage({id: 'EMAIL'})}
                      <span className='text-danger'> *</span>
                    </label>
                    <Field
                      type='text'
                      name='email'
                      className='form-control'
                      placeholder={intl.formatMessage({id: 'EMAIL'})}
                      maxLength={101}
                      onKeyUp={(e) => {
                        const value = e.target.value.toLowerCase()
                        const noTurkishChars = value.replaceAll(/[ğĞüÜşŞıİöÖçÇ]/g, '')
                        setFieldValue('email', noTurkishChars)
                      }}
                    />
                    {errors.email && touched.email && (
                      <div className='text-danger'>{errors.email}</div>
                    )}
                  </div>
                </div>
                <div className='w-100'>
                  <div className='form-group'>
                    <label className='form-label'>
                      {intl.formatMessage({id: 'PHONE'})}
                      <span className='text-danger'> *</span>
                    </label>
                    {/* <PatternFormat
                      name='phone'
                      className='form-control'
                      format='+1 (###) #### ###'
                      allowEmptyFormatting
                      mask='_'
                      value={values.phone || ''}
                      onValueChange={(values) => {
                        setFieldValue('phone', values.value)
                      }}
                    /> */}
                    <InputMask
                      mask='+1 (999) 999-9999'
                      className='form-control'
                      value={values.phone || ''}
                      onChange={(e) => {
                        console.log(e.target.value)
                        setFieldValue('phone', e.target.value)
                      }}
                      onClick={() => {
                        setTouched({...touched, phone: true})
                      }}
                      onBlur={() => {
                        setTouched({...touched, phone: true})
                      }}
                    />
                    {errors.phone && touched.phone && (
                      <div className='text-danger'>{errors.phone}</div>
                    )}
                  </div>
                </div>
              </div>
              <div className='w-50'>
                <div className='form-group'>
                  <label className='form-label'>{intl.formatMessage({id: 'TITLE'})}</label>
                  {/* <Field
                    type='text'
                    name='title'
                    className='form-control w-75'
                    placeholder={intl.formatMessage({ id: 'TITLE' })}
                  /> */}
                  {isLoadingTitle ? (
                    <></>
                  ) : (
                    // <Select
                    //   className='custom-select inline-table-select'
                    //   options={selects}
                    //   defaultValue={selects?.find((item) => item.value === values.titleID)}
                    //   onChange={(e) => setFieldValue('titleID', e?.value)}
                    // />
                    <Field
                      type='select'
                      as='select'
                      name='titleID'
                      className='form-control form-select w-50'
                      value={values.titleID}
                      onChange={(e) => setFieldValue('titleID', e.target.value)}
                    >
                      {selects?.map((select) => (
                        <option key={select.value} value={select.value}>
                          {select.label}
                        </option>
                      ))}
                    </Field>
                  )}

                  {errors.titleID && <div className='text-danger'>{errors.titleID}</div>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='d-flex flex-column w-100 mt-10 px-10'>
        <div className='bg-white w-75'>
          {/* public>terms.htm */}
          <iframe
            title='agreement'
            src='/terms.htm'
            style={{
              padding: 10,
              width: '100%',
              height: '100%',
              overflowY: 'hidden',
              border: '1px solid #dfdfdf',
              borderRadius: '5px',
              scrollbarColor: '#616161 transparent',
              scrollBehavior: 'smooth',
            }}
          ></iframe>
        </div>
        <div className='w-50 mt-5'>
          <Field type='checkbox' className='form-check-input' id='check' name='check' />
          <label className='form-label ms-4 fw-bold text-primary' htmlFor='check'>
            {/* I agree to the terms and conditions */}
            {intl.formatMessage({id: 'I_AGREE_TO_THE_TERMS_AND_CONDITIONS'})}
          </label>
          <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback mb-4'>
            {errors.check && touched.check && <div className='fv-help-block'>{errors.check}</div>}
          </div>
        </div>
      </div>

      <div className='w-100 mt-10 d-flex justify-content-center'>
        {isLoading ? (
          <button type='submit' className='btn btn-primary d-flex align-items-center' disabled>
            <i className='bi bi-arrow-right fs-3 me-3'></i>
            {/* Continue */}
            {intl.formatMessage({id: 'CONTINUE'})}
          </button>
        ) : (
          <button
            type='button'
            className='btn btn-primary d-flex align-items-center'
            onClick={() => {
              setTouched({...touched, phone: true})
              handleSubmit()
            }}
          >
            <i className='bi bi-arrow-right fs-3 me-3'></i>
            {/* Continue */}
            {intl.formatMessage({id: 'CONTINUE'})}
          </button>
        )}
      </div>
    </div>
  )
}
